export default class ReportTableColumns {
  constructor(Authentication, configurationProperty) {
    Object.assign(this, { Authentication, configurationProperty });
  }

  reset() {
    this.reportColumns = this.Authentication.user.settings.clientFlags[
      this.configurationProperty
    ].map((item) => ({ ...item }));
    this.needsSync = false;
  }

  configureClosed() {
    if (this.needsSync) {
      this.save();
    }
  }

  changed() {
    this.needsSync = true;
  }

  save() {
    this.Authentication.user.settings.clientFlags[this.configurationProperty] = this.reportColumns;
    this.Authentication.syncSettings();
    this.reset();
  }
}
